import Tooltip from '@mui/material/Tooltip';
import Typography, { type TypographyProps } from '@mui/material/Typography';
import { forwardRef, type Ref } from 'react';

type Props = {
  source?: string | null;
  sourceDescription?: string | null;
};

const SourceTypography = forwardRef((props: TypographyProps, ref: Ref<HTMLParagraphElement>) => (
  <Typography
    ref={ref}
    variant="body1"
    color="primary"
    {...props}
    sx={[
      {
        lineHeight: '18px',
      },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
  />
));

export const SourceCell = ({ source, sourceDescription }: Props) => {
  if (!source) {
    return null;
  }

  if (sourceDescription) {
    return (
      <Tooltip title={sourceDescription}>
        <SourceTypography>{source}</SourceTypography>
      </Tooltip>
    );
  }

  return <SourceTypography>{source}</SourceTypography>;
};
